import { useEffect, useState } from "react";
import ShareTransactionContributorRow from "../components/ShareTransactionContributorRow";

export default function ShareTransactionContributorList(props) {
  const {
    contributors,
    setContributorShareList,
    transaction,
    newTransaction,
    amount,
    contributorShareList,
    shouldReloadRow,
    resetShare,
    setResetShare,
    editMode
  } = props;
  //get shareAmount for each person
  const [dividedAmountList, setDividedAmountList] = useState([]);
  useEffect(() => {
    let totalShare = 0;
    const contributorKeys = Object.keys(contributorShareList);
    for (let i = 0; i < contributorKeys.length; i++) {
      totalShare = totalShare + (contributorShareList[contributorKeys[i]].share || 0);
    }
    
    const result = [];
    let calculatedTotal = 0;
    
    // Calculate amount for each contributor
    for (let i = 0; i < contributorKeys.length; i++) {
      let share = contributorShareList[contributorKeys[i]].share || 0;
      let curAmount = +((amount / totalShare) * share).toFixed(2);
      result.push(curAmount);
      calculatedTotal += curAmount;
    }
    
    // Assign rounding remainder to the last contributor with non-zero share
    const diff = +(amount - calculatedTotal).toFixed(2);
    if (diff !== 0) {
      // Find the last contributor with a non-zero share
      for (let i = contributorKeys.length - 1; i >= 0; i--) {
        if ((contributorShareList[contributorKeys[i]].share || 0) > 0) {
          result[i] = +(result[i] + diff).toFixed(2);
          break;
        }
      }
    }
    
    setDividedAmountList(result);
  }, [contributorShareList, amount]);

  return (
    <ul className="list-group list-group-flush">
      {contributors &&
        contributors.map((c, i) => (
          <li className="list-group-item" key={c.id}>
            <ShareTransactionContributorRow
              contributor={c}
              setContributorShareList={setContributorShareList}
              newTransaction={newTransaction}
              transaction={transaction}
              dividedAmount={dividedAmountList[i]}
              shouldReloadRow={shouldReloadRow}
              resetShare={resetShare}
              setResetShare={setResetShare}
              editMode={editMode}
            />
          </li>
        ))}
    </ul>
  );
}
